import { Button } from "../../ui/button";

export const PAGE_SIZE = 10;

export interface PagedResult<T> {
  items: T[];
  total: number;
  hasMore: boolean;
}

/** Prev/Next footer shared by every paginated table in Portfolio Performance --
 * same look as AthenaPricingEngine's Manage Targets log pager. */
export function Pager({
  offset,
  total,
  pageSize = PAGE_SIZE,
  isFetching,
  onChange,
}: {
  offset: number;
  total: number;
  pageSize?: number;
  isFetching?: boolean;
  onChange: (offset: number) => void;
}) {
  if (total <= pageSize) return null;
  return (
    <div className="mt-3 flex items-center justify-end gap-2 text-xs text-muted-foreground">
      <span className="tabular-nums">
        {`${offset + 1}–${Math.min(offset + pageSize, total)} of ${total}`}
      </span>
      <Button
        size="sm"
        variant="ghost"
        className="h-7 px-2 text-xs"
        disabled={offset === 0 || isFetching}
        onClick={() => onChange(Math.max(0, offset - pageSize))}
      >
        Prev
      </Button>
      <Button
        size="sm"
        variant="ghost"
        className="h-7 px-2 text-xs"
        disabled={offset + pageSize >= total || isFetching}
        onClick={() => onChange(offset + pageSize)}
      >
        Next
      </Button>
    </div>
  );
}
